import { ReferenceTupleBase } from "abweb/dto/generated/ds/ReferenceTupleBase";
export class ReferenceTuple extends ReferenceTupleBase {
  static createReferenceTuple(displayValue, value) {
    const retVal = new ReferenceTuple();
    retVal.initReferenceTuple(displayValue, value);
    return retVal;
  }
  constructor() {
    super();
  }

  /**
   * Returns true if the two specified references refer to the same object or are both undefined.
   */
  static isEqual(reference1, reference2) {
    if (reference1 === reference2) {
      return true;
    }
    if (reference1 == null || reference2 == null) {
      return false;
    }
    return reference1.displayValue === reference2.displayValue && reference1.value === reference2.value;
  }
}
//# sourceMappingURL=ReferenceTuple.js.map
